var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable import/no-cycle */
import React from 'react';
import cuid from 'cuid';
import { ThemeProvider, withTheme } from '@empiriecom/module-components/utils/styled-components';
import useIcon from '@empiriecom/module-components/utils/getIcon';
import useConfig from '../hooks/useConfig';
import buildLinkWithArguments from '../../utils/buildLinkWithArguments';
import setTargetCookie from '../../utils/setCookie';
import { flexibleTeaserTheme } from './theme';
import Wrapper, { WrapperAnchor } from './Wrapper';
var FlexibleTeaser = function (_a) {
    var _b, _c, _d, _e;
    var contentData = _a.contentData, _f = _a.componentKey, componentKey = _f === void 0 ? cuid() : _f;
    var config = useConfig();
    var ArrowLargeRight = useIcon('ArrowLargeRight');
    var _g = contentData.field_headline, dataHeadline = _g === void 0 ? null : _g, _h = contentData.field_text_subheadline, dataSubHeadline = _h === void 0 ? null : _h, _j = contentData.field_scaling_factor, styleScalingFactor = _j === void 0 ? 1 : _j, _k = contentData.field_layout_variant, styleType = _k === void 0 ? '0' : _k, _l = contentData.field_border_color, styleBorderColor = _l === void 0 ? 'rgba(0,0,0,0.5)' : _l, _m = contentData.field_background_color, styleBackgroundColor = _m === void 0 ? 'rgba(255,255,255,0.7)' : _m, _o = contentData.field_alignment, styleAlignment = _o === void 0 ? 'center' : _o, _p = contentData.field_vertical_alignment, styleVerticalAlignment = _p === void 0 ? 'center' : _p, _q = contentData.field_size, styleSize = _q === void 0 ? 'big' : _q, _r = contentData.field_size_subheadline, styleSizeSubHeadline = _r === void 0 ? 'small' : _r, _s = contentData.field_negative_text_color, styleIsNegativeTextColor = _s === void 0 ? false : _s, styleFont = contentData.field_font, styleFontSubHeadline = contentData.field_font_subheadline, _t = contentData.field_link, link = _t === void 0 ? '' : _t, persistTarget = contentData.field_persist_target, 
    /* eslint-disable @typescript-eslint/naming-convention */
    field_tracking = contentData.field_tracking, field_link_anchor = contentData.field_link_anchor, field_link_highlight = contentData.field_link_highlight, field_link_searchfilter = contentData.field_link_searchfilter, field_bonus_number = contentData.field_bonus_number;
    var styleScalingFactorMob = styleScalingFactor - 0.33;
    var styleScalingFactorTab = styleScalingFactor - 0.3;
    var WrapperProps = {
        styleScalingFactor: styleScalingFactor,
        styleScalingFactorMob: styleScalingFactorMob,
        styleScalingFactorTab: styleScalingFactorTab,
        styleType: styleType,
        styleBorderColor: styleBorderColor,
        styleBackgroundColor: styleBackgroundColor,
        styleAlignment: styleAlignment,
        styleVerticalAlignment: styleVerticalAlignment,
        styleSize: styleSize,
        styleSizeSubHeadline: styleSizeSubHeadline,
        styleIsNegativeTextColor: styleIsNegativeTextColor,
        styleFont: styleFont,
        styleFontSubHeadline: styleFontSubHeadline,
        className: 'cms-flexible-teaser',
        key: "cms-flexible-teaser-" + componentKey,
        tabletMinWidth: (_c = (_b = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c.tabletMinWidth,
        desktopMinWidth: (_e = (_d = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _d === void 0 ? void 0 : _d.values) === null || _e === void 0 ? void 0 : _e.desktopMinWidth,
    };
    var onClickProp = {
        onClick: function (e) {
            e.preventDefault();
            if (persistTarget) {
                setTargetCookie(link);
            }
            window.location.href = buildLinkWithArguments(link, {
                field_tracking: field_tracking,
                field_link_anchor: field_link_anchor,
                field_link_highlight: field_link_highlight,
                field_link_searchfilter: field_link_searchfilter,
                field_bonus_number: field_bonus_number,
            });
        },
    };
    var WrapperElement = function () {
        return link ? (React.createElement(WrapperAnchor, __assign({ "data-testid": "cms-flexible-teaser" }, __assign(__assign({}, WrapperProps), onClickProp)),
            dataHeadline && React.createElement("div", { className: "headline" }, dataHeadline),
            dataSubHeadline && React.createElement("div", { className: "sub-headline" }, dataSubHeadline),
            React.createElement(ArrowLargeRight, { className: "icon-arrow-right" }))) : (
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        React.createElement(Wrapper, __assign({ "data-testid": "cms-flexible-teaser" }, WrapperProps),
            dataHeadline && React.createElement("div", { className: "headline" }, dataHeadline),
            dataSubHeadline && React.createElement("div", { className: "sub-headline" }, dataSubHeadline),
            React.createElement(ArrowLargeRight, { className: "icon-arrow-right" })));
    };
    return (React.createElement(ThemeProvider, { theme: flexibleTeaserTheme },
        React.createElement(WrapperElement, null)));
};
export default withTheme(FlexibleTeaser);
//# sourceMappingURL=index.js.map